// import history from '@/history';
import { linkWhereFrom } from '@/common/utils/helper';
// import utils from '@/common/utils';
import env from '@/env/env.prod';
import allEnv from '@/env';

// export function setbaseLink(link: string) {
//   // 因为在频道页也需要内嵌收品池列表，所以新建了一个更新baseLink的函数，使用注意：需要在总入口处使用
//   baseLink = link;
// }

// 跳转类型默认是open
enum jumpType {
  open = 'open',
  href = 'href',
}

const jump = (url: string, type: jumpType = jumpType.open) => {
  type === jumpType.href && (window.location.href = linkWhereFrom(url));
  type === jumpType.open && window.open(linkWhereFrom(url), '_blank', 'noopener, noreferrer');
};

export type methodsJumptoMc =
  | 'jumpTower'
  | 'jumpCollection'
  | 'jumpInvite'
  | 'jumpPoolList'
  | 'jumpQualificationSettings'
  | 'jumpQualificationForAssembly'
  | 'jumpSceneSetting'
  | 'jumpDailyMaterialPoolrule'
  | 'jumpDailyViewSelectRule'
  | 'jumpPlatformViewSelectRule'
  | 'materialPoolruleNew'
  | 'jumpRegisteredMaterials'
  | 'jumpCollectionPoolSettings'
  | 'jumpAuditManagement'
  | 'jumpSignUp'
  | 'jumpDistributePage'
  | 'jumpCrossSessionJumps'
  | 'jumpActivityData'
  | 'jumpEffectData'
  | 'jumpActivityCreate'
  | 'jumpSalerAuditManagement'
  | 'jumpManage'
  | 'jumpMaterialPoolManage'
  | 'jumpSalerAuditManagement'
  | 'jumpPandora'
  | 'jumpMaterialHelper'
  | 'jumpSelectSetting'
  | 'jumpPandora'
  | 'jumpManageActivityList'
  | 'jumpJoinActivityList'
  | 'jumpUserSetting'
  | 'jumpMaterialsGroup'
  | 'jumpDailyGoodsStrategyNew'
  | 'jumpDailyGoodsStrategySet'
  | 'jumpStrategyGoodsRange'
  | 'jumpDailyGoodsStrategyDetail'
  | 'jumpStrategyDailyGoodSet'
  | 'jumpStrategyDailyGoodDetail'
  | 'jumpDailyMaterialPoolManage'
  | 'jumpNewCheckProcess'
  | 'jumpChannelService'
  | 'jumpVenues'
  | 'jumpVenuesPageDetail';

// 跳转方法
type typeMethod = (query: string, type: jumpType) => void;

type DataIntoMcMicroapp = Record<methodsJumptoMc, typeMethod>;

type DataType = DataIntoMcMicroapp & { sence: 'mc' | 'daily' } & {
  toChannelService: (query: { channelId: string }, type: jumpType) => void;
} & {
  inPlatformMarketing?: boolean;
};

function getDataThrowToMicroapp({ baseLink = '' }: { baseLink: string }): DataType {
  const data: DataType = {
    sence: 'mc',
    // 未内嵌通天塔
    jumpTower: (query, type) => {
      jump(baseLink + '/tower' + query, type);
    },
    // 管理者者提报收品池列表 & 效果数据
    jumpCollection: (query, type) => {
      jump(baseLink + '/pools' + query, type);
    },
    // 管理者者提报收品池列表 & 效果数据
    jumpInvite: (query, type) => {
      jump(baseLink + '/pools' + query, type);
    },
    // 参与者收品池列表 & 效果数据
    jumpPoolList: (query, type) => {
      jump(baseLink + '/poolList' + query, type);
    },
    // 资质设置
    jumpQualificationSettings: (query, type) => {
      jump(baseLink + '/qualification' + query, type);
    },
    // 资质平台页面
    jumpQualificationForAssembly: (query, type) => {
      jump(baseLink + '/qualificationForAssembly' + query, type);
    },
    // 场次设置
    jumpSceneSetting: (query, type) => {
      jump(baseLink + '/scene' + query, type);
    },
    // 门槛规则
    materialPoolruleNew: (query, type) => {
      jump('/platform-marketing' + query, type);
    },
    // 日常活动门槛规则
    jumpDailyMaterialPoolrule: (query, type) => {
      jump('/activity-manage/myCreate/daily-activities-manager/pool-rule' + query, type);
    },
    // 日常活动查看选品规则
    jumpDailyViewSelectRule: (query, type) => {
      jump('/activity-manage/myCreate/daily-activities-manager/view-select-rule' + query, type);
    },
    // 平台阵地活动查看选品规则
    jumpPlatformViewSelectRule: (query, type) => {
      jump('/platform-marketing/view-select-rule' + query, type);
    },
    // 已报名素材
    jumpRegisteredMaterials: (query, type) => {
      jump(baseLink + '/registeredMaterials' + query, type);
    },
    // 收品池设置
    jumpCollectionPoolSettings: (query, type) => {
      jump(baseLink + '/poolSetting' + query, type);
    },
    // 报名
    jumpSignUp: (query, type) => {
      jump(baseLink + '/signUp' + query, type);
    },
    // 分配
    jumpDistributePage: (query, type) => {
      jump(baseLink + '/distributePage/index' + query, type);
    },
    // 跨场次跳转
    jumpCrossSessionJumps: (query, type) => {
      jump(baseLink + '/crossSessionJumps/batchEditInfo' + query, type);
    },
    jumpVenues: (query, type) => {
      jump(baseLink + '/venues' + query, type);
    },
    jumpVenuesPageDetail: (query, type) => {
      jump(baseLink + '/venuesPageDetail' + query, type);
    },
    // 效果数据 在日常活动和频道阵地中被嵌入
    jumpEffectData(query, type) {
      // 管理者 jumpCollection
      // 参与者 jumpPoolList
      // 活动会场跳转的是列表页
      // entry: 1 参与者 0 管理者
      // const entry = utils.getQuery('entry', query);
      // if (entry === '1') return data.jumpPoolList(query, type);
      // if (entry === '0') return data.jumpCollection(query, type);
      return jump(baseLink + '/effectData' + query, type);
      // jump(baseLink + '/crossSessionJumps/batchEditInfo' + query, type);
    },
    // 流程数据 在日常活动和频道阵地中被嵌入
    jumpActivityData(query, type) {
      // 我和上面的如果没有流程数据就可以删掉了
      jump(baseLink + '/pools/manage/activityData/detail' + query, type);
    },
    // 登月报名进度
    // 除了流程数据都使用这个方法跳转
    // http://test.mc.jd.com/manage/ruleSetAndInvite?entry=0&activityId=10615028&blockId=14981136
    jumpManage(pathSuffix, type) {
      jump(baseLink + '/managemc' + pathSuffix, type);
    },
    // 创建会场活动
    jumpActivityCreate(query, type) {
      jump(baseLink + '/createRoomActivity' + query, type);
    },
    // 审核管理
    jumpAuditManagement: (query, type) => {
      jump(baseLink + '/auditManagement' + query, type);
    },
    // 2.0 商家运营审核
    jumpSalerAuditManagement(query, type) {
      jump(baseLink + '/auditManagement' + query, type);
    },
    // 跳转2.0下的1.0素材池管理页 只有主题活动会用到这个方法
    jumpMaterialPoolManage(query, type) {
      jump('/activity-manage/merchants/detail/room/myAdminMaterialPool/allRoomMaterialManage' + query, type);
    },
    // 跳转潘多拉
    jumpPandora(query, type) {
      jump('/pandora#' + query, type);
    },
    // 收藏素材跳转帮助中心
    jumpMaterialHelper() {
      jump(env.ACORE_DOMAIN + '/help/list/61?type=2&categoryIds=3');
    },
    // 新增选品助手
    jumpSelectSetting(query, type) {
      jump(baseLink + '/selectSetting' + query, type);
    },
    // 日常活动我管理的活动列表
    jumpManageActivityList(query, type) {
      // activityReceipt建设完毕，老的不要了，替换成新的【TODO:待和提报确认】
      // jump('/activity-manage/myCreate/room/manage' + query, type);
      if (query && query.length > 0 && query.indexOf('?') !== -1) {
        query = `${query}&tab=2`;
      } else {
        query = `?tab=2`;
      }
      jump('/activity-manage/myCreate/room/activityReceipt' + query, type);
    },
    // 日常活动我参与的活动列表
    jumpJoinActivityList(query, type) {
      // activityReceipt建设完毕，老的不要了，替换成新的【TODO:待和提报确认】tab=1或者不传，默认为原来的join,无需处理query
      //jump('/activity-manage/myCreate/room/join' + query, type);
      jump('/activity-manage/myCreate/room/activityReceipt' + query, type);
    },
    // // 跳转2.0下的1.0素材池管理页 只有主题活动会用到这个方法
    // jumpMaterialPoolManage(query, type) {
    //   jump('/activity-manage/merchants/detail/room/myAdminMaterialPool/allRoomMaterialManage' + query, type);
    // },
    // // 跳转潘多拉
    // jumpPandora(query, type) {
    //   jump('/pandora#' + query, type);
    // },
    jumpUserSetting(childPath, type) {
      jump('/user-setting' + childPath, type);
    },
    jumpNewCheckProcess(query, type) {
      jump(allEnv.NEWZHENDI + '/check-process/#/416' + query, type);
    },
    jumpMaterialsGroup(query, type) {
      jump(baseLink + '/materials' + query, type);
    },
    jumpDailyGoodsStrategyNew(query, type) {
      jump(baseLink + '/strategy-new' + query, type);
    },
    jumpDailyGoodsStrategySet(query, type) {
      jump(baseLink + '/strategy-set' + query, type);
    },
    jumpStrategyGoodsRange(query, type) {
      jump(baseLink + '/strategy-goods-range' + query, type);
    },
    jumpDailyGoodsStrategyDetail(query, type) {
      jump(baseLink + '/strategy-touch-detail' + query, type);
    },
    jumpStrategyDailyGoodSet(query, type) {
      jump(baseLink + '/strategy-daily-good-set' + query, type);
    },
    jumpStrategyDailyGoodDetail(query, type) {
      jump(baseLink + '/strategy-daily-good-detail' + query, type);
    },
    jumpDailyMaterialPoolManage(query, type) {
      jump(baseLink + '/strategy' + query, type);
    },
    jumpChannelService(query, type) {
      jump(`/channel-service${query}}`, type);
    },
    toChannelService(query = { channelId: '' }, type) {
      jump(`/channel-service/${query.channelId}`, type);
    },
  };

  return data;
}

// 会场的basename
let roombaseLink = '/activity-manage/merchants/venueDetail';

export const data = getDataThrowToMicroapp({ baseLink: roombaseLink });

export { jump, getDataThrowToMicroapp };
export type { DataType, typeMethod, jumpType };
